import {
  AUTOMATION_ACTION,
  AUTOMATION_STATE,
} from 'services/Automation2Service';

export const getToastMessage = (action, t) => {
  switch (action) {
    case AUTOMATION_ACTION.PAUSE:
      return {
        success: t('This agentic workflow has been paused'),
        failure: t('The agentic workflow could not be paused'),
      };
    case AUTOMATION_ACTION.RESUME:
      return {
        success: t('This agentic workflow has been resumed'),
        failure: t('The agentic workflow could not be resumed'),
      };
    case AUTOMATION_ACTION.CANCEL:
      return {
        success: t('The agentic workflow has been canceled'),
        failure: t('The agentic workflow could not be cancelled'),
      };
    case AUTOMATION_ACTION.SKIP_STEP_AND_RESUME:
      return {
        success: t('Agentic Workflow resumed successfully'),
        failure: t('Error Occurred - Could not resume agentic workflow'),
      };
    case AUTOMATION_ACTION.EXECUTION_HISTORY:
      return {
        success: t('Execution details opened.'),
        failure: t('There was an error opening the execution details.'),
      };
    default:
      return {};
  }
};

export const isExecutionImmutable = ({ status }) =>
  [
    AUTOMATION_STATE.COMPLETED,
    AUTOMATION_STATE.CANCELLED,
    AUTOMATION_STATE.FAILED,
  ].includes(status);
